import React from 'react';

const disabledMessage = (type) => <span>You are trying to order a <strong>{type}</strong> that is now no longer available. Please amend your order</span>;

export default {
  disabledProduct: disabledMessage('product'),
  disabledTheme: disabledMessage('style'),
  missingAttributes: 'Product option is unavailable: please choose different option before checkout.'
};
